unable to read source [project]/node_modules/src/ui/scanner/base.ts